import { QueryClient, QueryClientProvider } from "react-query";

import { AuthProvider } from "context/AuthContext";
import AuthenticationWrapper from "components/AuthenticationWrapper/AuthenticationWrapper";
import { ConfigProvider } from "antd";
import { ErrorBoundary } from "@sentry/react";
import ErrorScreen from "components/ErrorScreen/ErrorScreen";
import GlobalStyle from "theme/GlobalStyles";
import { NotificationProvider } from "context/NotificationsContext";
import ProviderTreeBuilder from "context/ProviderTreeBuilder";
import { ReactQueryDevtools } from "react-query/devtools";
import { colors } from "theme/theme";
import { geekblue } from "@ant-design/colors";
import { Security } from "@okta/okta-react";
import { oktaAuth } from "config/okta";

const queryClient = new QueryClient();

const ProviderTree = ProviderTreeBuilder([
  [QueryClientProvider, { client: queryClient }],
  [AuthProvider],
  [NotificationProvider],
]);

function App() {
  const restoreOriginalUri = (_oktaAuth: any, originalUri: string) => {
    window.location.replace(originalUri || "/");
  };

  return (
    <ErrorBoundary fallback={<ErrorScreen showReload />} showDialog>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: geekblue[6],
              colorText: colors.text,
            },
          }}
        >
          <GlobalStyle />
          <ProviderTree>
            <AuthenticationWrapper />
            <ReactQueryDevtools />
          </ProviderTree>
        </ConfigProvider>
      </Security>
    </ErrorBoundary>
  );
}

export default App;
